import { Component, inject, Input, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import { LoadingSpinnerBorderComponent } from "../../../shared/components/loading/loading-spinner-border/loading-spinner-border.component";
import { FormSubmission, FormSubmissionState } from '../../../shared/models/formSubmission.model';
import { FormIoViewData } from '../../../shared/models/formio.model';
import { SchemaService } from '../../../shared/services/schema.service';
import { SchemaRepository } from '../../../shared/repositories/schema.repository';
import { FormioComponent } from '@formio/angular';

@Component({
    selector: 'send-schema-dialog',
    imports: [CommonModule, LoadingSpinnerBorderComponent, TranslocoDirective],
    templateUrl: './send-schema-dialog.component.html',
    styleUrl: './send-schema-dialog.component.scss'
})
export class SendSchemaDialogComponent {
    private readonly schemaService = inject(SchemaService);
    private readonly schemaRepository = inject(SchemaRepository);

    @Input() formioData!: FormIoViewData;
    @Input() formSubmission!: FormSubmission;
    @Input() formIoComponent!: FormioComponent;
    @Input() isSchemaSending: WritableSignal<boolean> = signal(false);
    @Input() isSchemaSentSucces: WritableSignal<boolean> = signal(false);
    @Input() isSchemaSentError: WritableSignal<boolean> = signal(false);

    resetSignals(): void {
        this.isSchemaSending.set(true);
        this.isSchemaSentSucces.set(false);
        this.isSchemaSentError.set(false);
    }

    onSendSchema(): void {
        this.resetSignals();
        this.formSubmission = {
            schemaId: this.formSubmission.schemaId,
            schemaState: this.formSubmission.schemaState,
            submission: {
                data: this.formSubmission.submission.data,
                metadata: this.formSubmission.submission.metadata,
                state: FormSubmissionState.submitted,
                _vnote: this.formSubmission.submission._vnote
            },
            isAutoSave: false,
            version: this.formioData.version
        }
        this.schemaService.submitForm(this.formSubmission).subscribe({
            next: () => {
                this.schemaRepository.updateSchemaChangedDate(this.formioData.schemaId);
            },
            error: () => {
                this.isSchemaSending.set(false);
                this.isSchemaSentError.set(true);
            },
            complete: () => {
                this.isSchemaSending.set(false);
                this.isSchemaSentSucces.set(true);
            }
        });
    }

    onDialogClose() {
        window.location.reload();
    }

    onBack() {
        this.formIoComponent.refresh;
    }
}
